import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { HomeComponent } from './home/home.component';
import { setCurrentLocationId as setLocation } from '../../redux/actions/location/current-location';
import {
  getLocationHistory,
  removeLocationFromHistory,
} from '../../redux/actions/location/location-history/location-history.action';
import {
  getOrgHistory,
  removeOrgFromHistory,
} from '../../redux/actions/org/org-history/org-history.action';
import { selectHasWeaveAcl } from '../../redux/actions/auth/auth.selectors';
import { CoreACLs } from '../../redux/actions/auth/auth.types';

export const HomeContainer = withRouter(
  connect(
    (state: any, ownProps: any) => ({
      canCreateLocations: selectHasWeaveAcl(state, CoreACLs.WRITELOCATIONS),
      history: ownProps.history,
      locationHistoryList: state.locationHistory.history,
      orgHistoryList: state.orgHistory.history,
      loading: state.locationHistory.loading || state.orgHistory.loading,
    }),
    {
      loadLocationHistory: getLocationHistory,
      removeLocationFromHistory,
      loadOrgHistory: getOrgHistory,
      removeOrgFromHistory,
      setLocation,
    }
  )(HomeComponent)
);
